(() => {
  'use strict';

  const ZODIAC_CONFIG = {
    'zodiac-vedhaeng-vaedderen': { blue: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-vaedderen-blue-sapphire-overlay-replacement.png?v=1788025626', pink: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-vaedderen-pink-sapphire-overlay-replacement.png?v=1788025640', guld: '70492582936913', hvidguld: '70492583002449', rosaguld: '70492583035217', sterlingsolv: '71099580776785' },
    'zodiac-vedhaeng-tyren': { blue: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-tyren-blue-sapphire-overlay-replacement.png?v=1788025404', pink: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-tyren-pink-sapphire-overlay-replacement.png?v=1788025391', guld: '70492589719889', hvidguld: '70492589654353', rosaguld: '70492589752657', sterlingsolv: '71100043592017' },
    'zodiac-vedhaeng-tvillingen': { blue: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-tvillingen-blue-sapphire-overlay-replacement.png?v=1788025277', pink: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-tvillingen-pink-sapphire-overlay-replacement.png?v=1788025290', guld: '70492583395665', hvidguld: '70492583428433', rosaguld: '71100205138257', sterlingsolv: '71100116828497' },
    'zodiac-vedhaeng-krebsen': { blue: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-krebsen-blue-sapphire-overlay-1239.png?v=1788023708', pink: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-krebsen-pink-sapphire-overlay-1239.png?v=1788023696', guld: '70492584640849', hvidguld: '70492584608081', rosaguld: '70492584673617', sterlingsolv: '71100283486545' },
    'zodiac-vedhaeng-loeven': { blue: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-loeven-blue-sapphire-overlay-1239.png?v=1788023420', pink: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-loeven-pink-sapphire-overlay-1239.png?v=1788023439', guld: '70492585754961', hvidguld: '70492585787729', rosaguld: '70492585820497', sterlingsolv: '71100359180625' },
    'zodiac-vedhaeng-jomfruen': { blue: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-jomfruen-blue-sapphire-overlay-1239.png?v=1788023239', pink: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-jomfruen-pink-sapphire-overlay-1239.png?v=1788023251', guld: '70492585984337', hvidguld: '70492585951569', rosaguld: '70492586049873', sterlingsolv: '71100412526929' },
    'zodiac-vedhaeng-vaegten': { blue: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-vaegten-blue-sapphire-overlay-1239.png?v=1788023265', pink: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-vaegten-pink-sapphire-overlay-1239.png?v=1788023226', guld: '70492586639697', hvidguld: '70492586541393', rosaguld: '70492586606929', sterlingsolv: '71100457222481' },
    'zodiac-vedhaeng-skorpionen': { blue: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-skorpionen-blue-sapphire-overlay-1239.png?v=1788023102', pink: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-skorpionen-pink-sapphire-overlay-1239.png?v=1788023090', guld: '70492587393361', hvidguld: '70492587426129', rosaguld: '70492587327825', sterlingsolv: '71100519579985' },
    'zodiac-vedhaeng-skytteren': { blue: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-skytten-blue-sapphire-overlay-1239.png?v=1788022919', pink: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-skytten-pink-sapphire-overlay-1239.png?v=1788022930', guld: '70492587786577', hvidguld: '70492587852113', rosaguld: '70492587884881', sterlingsolv: '71100603433297' },
    'zodiac-vedhaeng-stenbukken': { blue: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-stenbukken-blue-sapphire-overlay.png?v=1788019910', pink: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-stenbukken-pink-sapphire-overlay-1239.png?v=1788022832', guld: '70492588179793', hvidguld: '70492588081489', rosaguld: '70492588147025', sterlingsolv: '71100713632081' },
    'zodiac-vedhaeng-vandmanden': { blue: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-vandmanden-blue-sapphire-overlay-1239.png?v=1788022606', pink: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-vandmanden-pink-sapphire-overlay-1239.png?v=1788022594', guld: '70492588507473', hvidguld: '70492588474705', rosaguld: '70492588409169', sterlingsolv: '71100799451473' },
    'fisken-stjernetegns-vedhaeng': { blue: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-fiskene-blue-sapphire-overlay-1239.png?v=1788022394', pink: 'https://cdn.shopify.com/s/files/1/1061/7507/0545/files/zodiac-fiskene-pink-sapphire-overlay-1239.png?v=1788022407', guld: '70492589064529', hvidguld: '70492589130065', rosaguld: '70492589162833', sterlingsolv: '71100894282065' }
  };

  const MATERIAL_MEDIA_KEYS = {
    'Guld': 'guld',
    'Gult guld': 'guld',
    'Hvidguld': 'hvidguld',
    'Rosaguld': 'rosaguld',
    'Sterlingsølv': 'sterlingsolv',
    'Sølv': 'sterlingsolv'
  };

  const MATERIAL_COPY = {
    'Guld': '18 kt gult guld',
    'Gult guld': '18 kt gult guld',
    'Hvidguld': '18 kt hvidguld',
    'Rosaguld': '18 kt rosaguld',
    'Sterlingsølv': '925 sølv',
    'Sølv': '925 sølv'
  };

  const STONE_COPY = {
    'Diamant': 'naturlig diamant',
    'Blå safir': 'blå safir',
    'Pink safir': 'pink safir'
  };

  const getOptionValue = (optionName, scope = document) => {
    const group = scope.querySelector?.(`.variant-options[data-option-name="${CSS.escape(optionName)}"]`)
      || document.querySelector(`.variant-options[data-option-name="${CSS.escape(optionName)}"]`);
    const selectedItem = group?.querySelector('.variant-option-item.selected, .variant-option-item[aria-checked="true"], .variant-option-item[aria-selected="true"]');
    if (selectedItem) {
      return selectedItem.dataset.swatch
        || selectedItem.querySelector('input')?.value
        || selectedItem.textContent.trim();
    }
    const select = scope.querySelector?.(`select[name="options[${CSS.escape(optionName)}]"]`)
      || document.querySelector(`select[name="options[${CSS.escape(optionName)}]"]`);
    return select?.value || '';
  };

  const findDetailLabel = (scope, label) => Array.from(scope.querySelectorAll('.mainProduct strong')).find(
    (element) => element.textContent.trim() === `${label}:`
  );

  const setDetailText = (labelElement, value) => {
    const item = labelElement?.closest('li');
    if (!item || !value) return;
    const currentValue = item.textContent.replace(labelElement.textContent, '').trim();
    if (currentValue === value) return;
    while (labelElement.nextSibling) labelElement.nextSibling.remove();
    item.appendChild(document.createTextNode(` ${value}`));
  };

  const syncOverlayGeometry = (gallery) => {
    gallery.querySelectorAll('.gemmarii-zodiac-stone-overlay').forEach((overlay) => {
      const slide = overlay.closest('.media-child');
      const baseImage = slide?.querySelector('img:not(.gemmarii-zodiac-stone-overlay)');
      if (!slide || !baseImage) return;

      const slideRect = slide.getBoundingClientRect();
      const imageRect = baseImage.getBoundingClientRect();
      if (!imageRect.width || !imageRect.height) return;

      overlay.style.setProperty('top', `${imageRect.top - slideRect.top}px`, 'important');
      overlay.style.setProperty('left', `${imageRect.left - slideRect.left}px`, 'important');
      overlay.style.setProperty('width', `${imageRect.width}px`, 'important');
      overlay.style.setProperty('height', `${imageRect.height}px`, 'important');
    });
  };

  const updateCopy = (gallery, material, stone) => {
    const productRoot = gallery.closest('.mainProduct') || document;
    const materialText = MATERIAL_COPY[material] || material || '';
    const stoneText = STONE_COPY[stone] || stone || '';
    const choiceSummary = productRoot.querySelector('.gemmarii-zodiac-intro p:first-child');
    const summaryText = materialText && stoneText ? `${materialText} med ${stoneText}` : '';
    if (choiceSummary && summaryText && choiceSummary.textContent.trim() !== summaryText) {
      choiceSummary.textContent = summaryText;
    }

    setDetailText(findDetailLabel(productRoot, 'Materiale'), materialText);
    const diamondLabel = gallery.dataset.gemmariiDiamondLabel || 'Diamant';
    const stoneDetail = /^(naturlig\s+)?diamant$/i.test(stone.trim())
      ? diamondLabel
      : stoneText ? stoneText.charAt(0).toUpperCase() + stoneText.slice(1) : '';
    setDetailText(findDetailLabel(productRoot, 'Centralsten') || findDetailLabel(productRoot, 'Sten'), stoneDetail);
  };

  const updateOverlay = (gallery) => {
    const productRoot = gallery.closest('.mainProduct') || document;
    const stone = getOptionValue('Sten', productRoot);
    const material = getOptionValue('Materiale', productRoot);
    updateCopy(gallery, material, stone);

    const config = ZODIAC_CONFIG[gallery.dataset.productHandle] || null;
    if (!config) return;

    const normalizedStone = stone.trim().toLocaleLowerCase('da-DK');
    const source = normalizedStone === 'blå safir'
      ? config.blue
      : normalizedStone === 'pink safir'
        ? config.pink
        : '';

    const mediaKey = MATERIAL_MEDIA_KEYS[material];
    const mediaId = mediaKey ? config[mediaKey] : '';
    const overlayMediaIds = new Set(mediaId
      ? [String(mediaId)]
      : Object.values(MATERIAL_MEDIA_KEYS).map((key) => String(config[key] || '')).filter(Boolean));

    if (mediaId) {
      gallery.dispatchEvent(new CustomEvent('gemmarii:variant-media-selected', {
        bubbles: true,
        detail: { mediaId: String(mediaId) }
      }));
    }

    syncOverlayGeometry(gallery);
    gallery.querySelectorAll('.gemmarii-zodiac-stone-overlay').forEach((overlay) => {
      const overlayMediaId = String(overlay.dataset.gemmariiZodiacMedia || '').split('/').pop();
      const show = Boolean(source && overlayMediaIds.has(overlayMediaId));
      overlay.style.display = show ? 'block' : 'none';
      if (show && overlay.src !== source) overlay.src = source;
    });
  };

  const initGallery = (gallery) => {
    if (gallery.dataset.gemmariiOverlayReady === 'true') return;
    gallery.dataset.gemmariiOverlayReady = 'true';

    let syncTimer = 0;
    const scheduleUpdate = () => {
      clearTimeout(syncTimer);
      syncTimer = window.setTimeout(() => updateOverlay(gallery), 40);
    };

    const productRoot = gallery.closest('.mainProduct') || document;
    productRoot.addEventListener('change', (event) => {
      if (event.target.matches('input[name^="options["], select[name^="options["]')) scheduleUpdate();
    });
    productRoot.addEventListener('click', (event) => {
      if (event.target.closest('.variant-option-item')) scheduleUpdate();
    });

    gallery.querySelectorAll('.media-child img:not(.gemmarii-zodiac-stone-overlay)').forEach((image) => {
      if (!image.complete) image.addEventListener('load', scheduleUpdate, { once: true });
    });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => syncOverlayGeometry(gallery));
      gallery.querySelectorAll('.media-child').forEach((slide) => observer.observe(slide));
      gallery.gemmariiResizeObserver = observer;
    } else {
      window.addEventListener('resize', () => syncOverlayGeometry(gallery), { passive: true });
    }

    updateOverlay(gallery);
  };

  const init = (root = document) => {
    root.querySelectorAll?.('wdt-main-media[data-gemmarii-zodiac-overlay]').forEach(initGallery);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target || document));
})();
